/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Portal_Features_LedeInputs */

const en_portal_features_lede = /** @type {(inputs: Portal_Features_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your coach's times, your plan, your meals and your progress. One account, on your phone and on the web.`)
};

const pl_portal_features_lede = /** @type {(inputs: Portal_Features_LedeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terminy trenera, twój plan, posiłki i postępy. Jedno konto, w telefonie i w przeglądarce.`)
};

/**
* | output |
* | --- |
* | "Your coach's times, your plan, your meals and your progress. One account, on your phone and on the web." |
*
* @param {Portal_Features_LedeInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const portal_features_lede = /** @type {((inputs?: Portal_Features_LedeInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Portal_Features_LedeInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_portal_features_lede(inputs)
	return en_portal_features_lede(inputs)
});